import { z } from 'zod';
/**
 * 배너 — 콘솔에서 바꾸는 그림 두 장 (2026-09-26).
 *
 *   hero     홈 히어로. 기본은 `HERO_IMAGE`(cdn 의 hero-0912). 올린 것이 있으면 그것.
 *   offside  본문 오른쪽 아래 고정 배너. 기본은 orchard-banner-540.
 *
 * 그림 바이트는 콘솔 → R2 로 바로 간다(서명 URL). 서버는 어느 키가 어느 자리에 걸렸는지만 안다.
 * 콘솔이 올리기 전에 WebP 로 바꾸고 이름을 `banners/<uuid>.webp` 로 받는다 — 서버가 키를 정한다.
 */
export const BANNER_SLOTS = ['hero', 'offside'];
export const BANNER_SLOT_LABEL = {
    hero: '홈 히어로 배너',
    offside: '우하단 고정 배너',
};
/** 콘솔이 줄이는 폭 상한. 히어로는 본문 폭(896px)의 2x 가 안 되게, 고정 배너는 260px 의 2x. */
export const BANNER_MAX_WIDTH = { hero: 1400, offside: 540 };
/** 배너 한 장 상한. 히어로 1400w WebP 가 200KB 안팎이라 넉넉하다. */
export const BANNER_MAX_BYTES = 4 * 1024 * 1024;
export const bannerSignSchema = z.object({
    size: z.number().int().positive().max(BANNER_MAX_BYTES),
});
/** 올린 뒤 자리에 건다. `key` 는 서명 때 서버가 준 것이어야 한다 (`banners/<uuid>.webp`). */
export const bannerCommitSchema = z.object({
    key: z.string().regex(/^banners\/[0-9a-f-]{36}\.webp$/),
    width: z.number().int().min(1).max(8000),
    height: z.number().int().min(1).max(8000),
});
//# sourceMappingURL=banners.js.map